import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import PublicSite from "@/pages/PublicSite";
import OrderPage from "@/pages/OrderPage";
import TrackPage from "@/pages/TrackPage";
import SubscribePage from "@/pages/SubscribePage";
import AdminPortal from "@/pages/AdminPortal";
import ManifestPage from "@/pages/admin/ManifestPage";
import RouteMapPage from "@/pages/admin/RouteMapPage";

function App() {
  useEffect(() => {
    document.body.classList.remove("dark");
  }, []);

  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/track" element={<TrackPage />} />
            <Route path="/subscribe" element={<SubscribePage />} />
            <Route path="/admin" element={<AdminPortal />} />
            <Route path="/admin/manifest/:runId" element={<ManifestPage />} />
            <Route path="/admin/route/:runId" element={<RouteMapPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
